import * as React from 'react';
import { withNodeResizable } from '../shared/NodeResizable';
import { Portal } from '../shared/Portal';
import { createEmbedExtension } from '../shared/createEmbedExtension';
import { EmbedRendererProps } from '../shared/types';

const URL_REGEX = /https?:\/\/whimsical.com\/[0-9a-zA-Z-_~]*-([a-zA-Z0-9]+)\/?/;
export const ENABLED = [URL_REGEX];

export const Component = ({ url, ...rest }: EmbedRendererProps<any>) => {
  const boardId = React.useMemo(() => {
    const matches = URL_REGEX.exec(url);
    return matches ? matches[1] : '';
  }, [url]);

  return (
    <Portal
      {...rest}
      url={`https://whimsical.com/embed/${boardId}`}
      title="Whimsical"
      fullHeight
      withMetadata
    />
  );
};

export default createEmbedExtension({
  regexp: [URL_REGEX],
  name: 'whimsical-embed',
  component: withNodeResizable(Component, {
    lockAspectRatio: true,
  }),
  addCommandOption: {
    title: 'Whimsical',
    description: 'Embed a Whimsical board.',
    searchTerms: ['embed', 'whimsical'],
    icon: 'tabler:layout-board',
  },
});
